import * as React from 'react'
import * as styles from './FormLayout.css'

interface FormLayoutProps {
  title: string
  children: any
}

const FormLayout: React.FunctionComponent<FormLayoutProps> = ({ title, children }) => {
  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <p className={styles.titleText}>{title}</p>
      </div>
      <div className={styles.input}>{children}</div>
    </div>
  )
}

export default FormLayout
